import * as React from 'react'
import * as Styles from './HomeMenu.style'
import { getUnifyTextLen, replaceWkDomain } from '../../../../utils/tools'
import {classes} from 'typestyle'
import { RegisterElement } from '../../../../services/hotspotReport'
import { reportClickEvent } from '@weike/operation-report'

interface HomeMenuProps {
    content: HomeMenuIcon[]
}

interface HomeMenuIcon {
    icon: string,
    link: string,
    name: string,
    tag: string
}

function HomeMenu(props: HomeMenuProps) {

    const linkTo = (item: HomeMenuIcon, index: number) => {
        reportClickEvent(RegisterElement.top_icon, {index, url: item.link})
        setTimeout(() => window.location.href = replaceWkDomain(item.link), 150)
    }

    return (
        <div className={Styles.HomeMenu}>
        {props.content !== undefined && props.content.map((v: HomeMenuIcon, index) => (
             <div className={Styles.HomeMenuItem} key={index} onClick={() => linkTo(v, index)}>
                <div className={Styles.HomeMenuItemIconWrap}><img className={Styles.HomeMenuItemIcon} src={v.icon} alt=""/>
                    {v.tag !== '' && <div className={classes(Styles.HomeMenuItemIconContent, 'HomeMenuItemIconActive')} style={{right: -(getUnifyTextLen(v.tag) / 2) * 8.5}}><span className={classes(Styles.HomeMenuItemIconTopTips, 'HomeMenuItemIconActive')}>{v.tag}</span></div>}
                </div>
                <p className={Styles.HomeMenuItemText}>{v.name}</p>
            </div>
        ))}
        </div>
    )
}

export default HomeMenu



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeMenu/HomeMenu.tsx